__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "retail360_web_app";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.7.16", () => (Promise.all([__webpack_require__.e(2829), __webpack_require__.e(1535), __webpack_require__.e(8603), __webpack_require__.e(3426)]).then(() => (() => (__webpack_require__(48603))))));
			register("@okta/okta-auth-js", "7.8.1", () => (Promise.all([__webpack_require__.e(8266), __webpack_require__.e(2284)]).then(() => (() => (__webpack_require__(38266))))));
			register("@okta/okta-react", "6.7.0", () => (Promise.all([__webpack_require__.e(3426), __webpack_require__.e(5053), __webpack_require__.e(3963)]).then(() => (() => (__webpack_require__(83963))))));
			register("antd", "5.25.4", () => (Promise.all([__webpack_require__.e(3727), __webpack_require__.e(7639), __webpack_require__.e(7497), __webpack_require__.e(3426), __webpack_require__.e(5929), __webpack_require__.e(7756)]).then(() => (() => (__webpack_require__(47497))))));
			register("apollo-upload-client", "17.0.0", () => (Promise.all([__webpack_require__.e(2829), __webpack_require__.e(1535), __webpack_require__.e(3715)]).then(() => (() => (__webpack_require__(43715))))));
			register("i18next", "23.7.6", () => (Promise.all([__webpack_require__.e(4978), __webpack_require__.e(9379)]).then(() => (() => (__webpack_require__(44978))))));
			register("moment", "2.29.4", () => (__webpack_require__.e(6178).then(() => (() => (__webpack_require__(86178))))));
			register("react-circular-progressbar", "2.1.0", () => (Promise.all([__webpack_require__.e(3426), __webpack_require__.e(5826)]).then(() => (() => (__webpack_require__(95826))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(7950), __webpack_require__.e(3426)]).then(() => (() => (__webpack_require__(97950))))));
			register("react-i18next", "13.4.1", () => (Promise.all([__webpack_require__.e(3426), __webpack_require__.e(4117)]).then(() => (() => (__webpack_require__(74117))))));
			register("react-redux", "8.1.2", () => (Promise.all([__webpack_require__.e(2166), __webpack_require__.e(3426), __webpack_require__.e(5929), __webpack_require__.e(8587)]).then(() => (() => (__webpack_require__(22166))))));
			register("react-router-dom", "6.7.0", () => (Promise.all([__webpack_require__.e(1387), __webpack_require__.e(5475), __webpack_require__.e(3426), __webpack_require__.e(5830)]).then(() => (() => (__webpack_require__(35475))))));
			register("react-router", "6.7.0", () => (Promise.all([__webpack_require__.e(1387), __webpack_require__.e(3216), __webpack_require__.e(3426)]).then(() => (() => (__webpack_require__(73216))))));
			register("react-select", "5.4.0", () => (Promise.all([__webpack_require__.e(601), __webpack_require__.e(3426), __webpack_require__.e(5929), __webpack_require__.e(7877)]).then(() => (() => (__webpack_require__(50601))))));
			register("react", "15.7.0", () => (Promise.all([__webpack_require__.e(4766), __webpack_require__.e(3516)]).then(() => (() => (__webpack_require__(4766))))));
			register("react", "18.2.0", () => (__webpack_require__.e(5043).then(() => (() => (__webpack_require__(65043))))));
			register("styled-components", "5.3.5", () => (Promise.all([__webpack_require__.e(8747), __webpack_require__.e(3426)]).then(() => (() => (__webpack_require__(88747))))));
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(6453).then(() => (() => (__webpack_require__(46453))))));
			initExternal(34169);
			initExternal(69528);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};